import React, { useState } from "react";

const faqs = [
  {
    q: "¿Quiénes somos?",
    a: (
      <p>
        Transferven es la plataforma elegida por la mayoría de los Venezolanos
        para sus envíos de Dinero. Somos un equipo de profesionales con más de 9
        años en el sector de remesas hacia Venezuela. Como Empresa Regulada,
        cumplimos con los más estrictos Protocolos de Seguridad para evitar el
        fraude y ofrecer una experiencia 100% Segura a todos los usuarios.
      </p>
    ),
  },
  {
    q: "¿Qué es una Cuenta Transferven?",
    a: (
      <p>
        Es tu Panel de Control personal, desde donde podrás gestionar tus Envíos
        y revisar tu Historial de Transacciones 24/7/365.
      </p>
    ),
  },
  {
    q: "¿Cómo enviar dinero con Transferven?",
    a: (
      <p>
        Es muy sencillo. Abre tu Cuenta Transferven{" "}
        <a href="https://transferven.com/registro" target="_blank" rel="noreferrer">
          AQUÍ
        </a>{" "}
        o contacta directamente con Atención Personalizada a través de Whatsapp{" "}
        <a href="https://wa.me/34620818181" target="_blank" rel="noreferrer">
          AQUÍ
        </a>
        . Podrás gestionar tus Envíos 24 Hrs. desde tu Panel de Control.
      </p>
    ),
  },
  {
    q: "¿Cuánto tarda en llegar el dinero?",
    a: (
      <p>
        Tu Envío se procesará el mismo día que se reciba tu pago. Todas nuestras
        operaciones Banco a Banco se realizan de forma inmediata.
      </p>
    ),
  },
  {
    q: "¿Tipos de Entrega?",
    a: (
      <p>
        Transferimos directamente a la Cuenta Bancaria o Pago Móvil que nos
        indiques. Trabajamos con todas las Entidades Bancarias de Venezuela y
        enviamos también a otros países de Latinoamérica.
      </p>
    ),
  },
  {
    q: "¿Cómo pago mi Envío?",
    a: (
      <p>
        Puedes pagar con Tarjeta de Débito/Crédito, Transferencia Bancaria y
        PSD2.
      </p>
    ),
  },
  {
    q: "¿Cómo contacto con Atención al Cliente?",
    a: (
      <p>
        Ponemos a tu disposición un Chat Online{" "}
        <a href="https://wa.me/34620818181" target="_blank" rel="noreferrer">
          AQUÍ
        </a>
        , una sección para enviar Emails desde nuestra web y un Servicio
        Telefónico de Atención al Cliente al +34 91 993 13 12.
      </p>
    ),
  },
];

const FAQS = () => {
  // Set to 0 if you'd rather have the first item open by default.
  const [open, setOpen] = useState(-1);

  const toggle = (i) => setOpen((prev) => (prev === i ? -1 : i));

  return (
    <div className="wv-faq">
      <style>{`
        .wv-faq {
          /* --- brand accent (Walletven red). Change here if the exact hex differs --- */
          --accent: #F6394F;
          --q-color: #131a2b;
          --a-color: #667085;
          --divider: #ececec;
          --icon: #9aa0ac;

          max-width: 900px;
          margin: 110px auto 70px auto;
          padding: 0 20px;
          box-sizing: border-box;
        }
        .wv-faq * { box-sizing: border-box; }

        .wv-faq .wv-faq-title {
          text-align: center;
          text-transform: uppercase;
          font-weight: 800;
          font-size: 2.3rem;
          letter-spacing: 0.01em;
          color: #0f1620;
          margin: 0 0 40px;
        }

        .wv-faq .wv-faq-item { border-bottom: 1px solid var(--divider); }

        .wv-faq .wv-faq-q {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          background: none;
          border: none;
          cursor: pointer;
          text-align: left;
          padding: 26px 4px;
          font-size: 1.08rem;
          font-weight: 700;
          color: var(--q-color);
          transition: color 0.15s ease;
        }
        .wv-faq .wv-faq-q:hover { color: #000000; }

        .wv-faq .wv-faq-icon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          color: var(--icon);
          transition: transform 0.28s ease;
        }
        .wv-faq .wv-faq-item.open .wv-faq-icon { transform: rotate(180deg); }

        .wv-faq .wv-faq-answer {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows 0.28s ease;
        }
        .wv-faq .wv-faq-item.open .wv-faq-answer { grid-template-rows: 1fr; }

        .wv-faq .wv-faq-answer-inner { overflow: hidden; min-height: 0; }

        .wv-faq .wv-faq-answer-inner p {
          margin: 0;
          padding: 0 4px 28px;
          color: var(--a-color);
          font-size: 1rem;
          line-height: 1.7;
        }

        .wv-faq .wv-faq-answer-inner a {
          color: var(--accent);
          font-weight: 600;
          text-decoration: none;
        }
        .wv-faq .wv-faq-answer-inner a:hover { text-decoration: underline; }

        @media (max-width: 640px) {
          .wv-faq .wv-faq-title { font-size: 1.8rem; margin-bottom: 28px; }
          .wv-faq .wv-faq-q { font-size: 0.98rem; padding: 22px 2px; }
        }
      `}</style>

      <h1 className="wv-faq-title">Preguntas Frecuentes</h1>

      <div className="wv-faq-list">
        {faqs.map((item, i) => (
          <div key={i} className={`wv-faq-item ${open === i ? "open" : ""}`}>
            <button
              type="button"
              className="wv-faq-q"
              onClick={() => toggle(i)}
              aria-expanded={open === i}
            >
              <span>{item.q}</span>
              <svg
                className="wv-faq-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div className="wv-faq-answer">
              <div className="wv-faq-answer-inner">{item.a}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQS;